<template>
  <div v-click-outside="handleClickOutside" class="dropdown">
    <slot name="reference" />
    <slide-y-up-transition>
      <div v-if="value" class="dropdown__list">
        <slot />
      </div>
    </slide-y-up-transition>
  </div>
</template>

<script>
import { SlideYUpTransition } from 'vue2-transitions'

export default {
  name: 'Dropdown',
  components: { SlideYUpTransition },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    handleClickOutside() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="scss">
.dropdown {
  width: 100%;
  position: relative;

  &__list {
    position: absolute;
    top: calc(100% - -12px);
    left: 0;
    right: 0;
    margin: auto;
    background: $white;
    box-shadow: 0 0 16px rgba($deepdark, 0.12);
    border-radius: 12px;
    padding: 16px;
    min-width: 100px;
  }
}
</style>
